import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const skipCredentials = new HttpContextToken<boolean>(() => false);

@Injectable()
export class CrossOriginInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (req.context.get(skipCredentials)) {
      return next.handle(req);
    }
    return next.handle(req.clone({ withCredentials: true }));
  }
}
